import React from "react";
import { OfferLink } from "./OfferLink";
import { CtaMicrocopy } from "./CtaMicrocopy";
import { ctaMicrocopy, offer } from "../data/offer";
export function MidOfferSection() {
  return <section className="bg-canvas px-5 pb-16 md:pb-24" data-id="element-147" data-mp="15y1k6qoqhig4">
      <div className="mx-auto max-w-4xl rounded-[2rem] bg-navy px-6 py-12 text-center md:px-14 md:py-16" data-id="element-148" data-mp="15xjfr6rx3xx4">
        <h2 className="mx-auto max-w-2xl font-display text-[1.75rem] font-extrabold leading-[1.12] tracking-tight text-white md:text-[2.4rem]" data-id="element-149" data-mp="1av1iugj97ix7">
          Don't Wait Until the Hard Questions Catch Your Child <span className="text-gold" data-id="element-150" data-mp="11xitizykuifi">Off Guard.</span>
        </h2>
        <div className="mx-auto mt-5 max-w-xl space-y-2 text-lg leading-relaxed text-white/85" data-id="element-151" data-mp="n8csr7k3ck5i">
          <p data-id="element-152" data-mp="s7fyku7wauej">Your child's faith deserves more than memorized answers.</p>
          <p data-id="element-153" data-mp="e6vdfreicmhv">Help them begin exploring the reasons behind Christian beliefs today.</p>
        </div>

        <div className="mt-8 flex flex-col items-center gap-1" data-id="element-154" data-mp="i7ytadwk2ij3">
          <p className="text-base text-white/70" data-id="element-155" data-mp="iab9alir6iti">
            Regular Price: <s data-id="element-156" data-mp="2hlrzf12u1obw">{offer.regularPrice}</s>
          </p>
          <p className="flex items-baseline gap-3" data-id="element-157" data-mp="2co08a9a0i68r">
            <span className="text-base font-semibold uppercase tracking-wider text-white/85" data-id="element-158" data-mp="2cn71j8b1zgqm">Special Price:</span>
            <span className="font-display text-6xl font-extrabold leading-none text-gold" data-id="element-159" data-mp="2rkhigx6gtetq">{offer.price}</span>
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-160" data-mp="1ywbxqafevptw">
          <OfferLink label={`Yes! I Want the Complete Bundle for ${offer.price}`} data-id="element-161" data-mp="1yx3i0p3k614v" />
          <CtaMicrocopy items={ctaMicrocopy.mid} tone="light" data-id="element-162" data-mp="1tyjuwld8ajax" />
        </div>
      </div>
    </section>;
}